document.addEventListener('DOMContentLoaded', function () {
  var buttons = document.querySelectorAll('[id^="toggleButton"]')
  var body = document.body
  var count = 0

  // Funktion zum Setzen eines Cookies
  function setCookie(name, value, days) {
    var expires = ''
    if (days) {
      var date = new Date()
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000)
      expires = '; expires=' + date.toUTCString()
    }
    document.cookie = name + '=' + (value || '') + expires + '; path=/'
  }

  // Funktion zum Abrufen eines Cookies
  function getCookie(name) {
    var nameEQ = name + '='
    var ca = document.cookie.split(';')
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i]
      while (c.charAt(0) == ' ') c = c.substring(1, c.length)
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length)
    }
    return null
  }

  // Funktion zum Anwenden der Schriftgröße
  function applyFontSize(size) {
    body.classList.remove('fz-m', 'fz-l', 'fz-xl')
    body.classList.add(size)
    setCookie('fontSize', size)
    count = size === 'fz-l' ? 1 : size === 'fz-xl' ? 2 : 0

    // Sende ein benutzerdefiniertes Ereignis
    document.dispatchEvent(new CustomEvent('fontSizeChanged', { detail: size }))
  }

  // Beim Laden der Seite die Schriftgröße aus dem Cookie anwenden
  var savedSize = getCookie('fontSize')
  if (savedSize) {
    applyFontSize(savedSize)
  }

  // Event-Listener für die Buttons
  buttons.forEach(function (button) {
    button.addEventListener('click', function () {
      count++
      if (count === 1) {
        applyFontSize('fz-l')
      } else if (count === 2) {
        applyFontSize('fz-xl')
      } else {
        applyFontSize('fz-m')
        count = 0 // Reset count
      }
    })
  })

  // Listener für externe Änderungen
  document.addEventListener('fontSizeChangeRequested', function (event) {
    applyFontSize(event.detail)
  })
})
